import CryptoJS from "crypto-js";
const SECRET = process.env.REACT_APP_RESPONSE_SECRET;
const key = CryptoJS.SHA256(SECRET);
// Global encryption flag
let isEncryptionEnabled = true;
export const setEncryptionEnabled = (value) => {
  isEncryptionEnabled = value;
};
// Encrypt Request
export function encryptRequest(data) {
  if (!isEncryptionEnabled) return data;

  if (typeof FormData !== "undefined" && data instanceof FormData) {
    return data;
  }

  const iv = CryptoJS.lib.WordArray.random(16);
  const encrypted = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    key,
    {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );
  const payload = {
    iv: iv.toString(CryptoJS.enc.Hex),
    data: encrypted.ciphertext.toString(CryptoJS.enc.Hex),
  };
  return { payload };
}
// Decrypt Response
export function decryptResponse(response) {
  if (!isEncryptionEnabled) return response;

  if (!response?.payload?.iv || !response?.payload?.data) {
    return response;
  }
  try {
    const { iv, data } = response.payload;
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: CryptoJS.enc.Hex.parse(data) },
      key,
      {
        iv: CryptoJS.enc.Hex.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedText);
  } catch (err) {
    console.error("decryptResponse error:", err);
    return response;
  }
}